import React, { useContext } from 'react';
import { Form, Input, Button, Layout, Row, Col } from 'antd';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { authenticationService } from '../../services';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import "./Login.css";
import AppHeading from '../../components/AppHeading';
import { GlobalContext } from '../../contexts/GlobalContext';
const { Header, Footer, Sider, Content } = Layout;

const Login = (props) => {
  const { errorHandler, successHandler } = useContext(GlobalContext);
  const history = useHistory()

  if (authenticationService.currentUserValue && authenticationService.currentUserValue.name) {
    if (!props.location.state) {
      history.go(-1)
    }
    else {
      history.push(`${props.location.state.from.pathname}`);
    }
  }

  const onFinish = async (credentials) => {
    try {
      const trimmedCredentials= {email:credentials.email.trim(),password:credentials.password.trim()}
      const user = await authenticationService.login(trimmedCredentials);
      console.debug("Got response login:", user)

      if (user && user.name.length) {
        successHandler("Uspješno ste se prijavili u sustav!")
        history.go(0)
      }
      else {
        errorHandler("Neispravno korisničko ime ili lozinka!")
      }
    }
    catch (error) {
      console.error('Failed login:', error);
      errorHandler("Pogreška prilikom prijave u sustav!")
    }
  };

  const onFinishFailed = errorInfo => {
    console.error('Finish failed login:', errorInfo);
    errorHandler("Pogreška prilikom prijave u sustav!")

  };

  const prevPath = props.location.state ? props.location.state.from.pathname : null;

  return (
    <div>
      <Layout>
        <AppHeading dark={true}></AppHeading>
        <Content className="login__content">
          <div className="white-box-login">
            <h1 className='login__title'>Prijava u CikloParking</h1>
            <Form
              name="login"
              className="login-form"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite vaš e-mail!',
                  },
                ]}
              >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="E-mail" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite lozinku!',
                  },
                ]}
              >
                <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Lozinka" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button">
                  Prijava
                </Button>
              </Form.Item>
              {
                prevPath == "/app/entity" &&
                <p className="login__register">Nemate korisnički račun? <a href="register">Registrirajte se</a></p>
              }
            </Form>
          </div>
        </Content>
      </Layout>
    </div>
  );
}

export default Login;
